import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ScheduleDto } from "./getServiceTypeDetail.command";

export class AddServiceTypeCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IAddServiceTypeCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/create';

  public setParametersUrl(carrierId: string) {
    this._commandUrl = this._commandUrl.replace(
        '{carrierId}',
        carrierId.toString()
    );
  }

  public override setParameters(parameters: IAddServiceTypeCommandParameters) {
    this._commandBody = parameters;
  }
}

export interface IAddServiceTypeCommandParameters
  extends ServiceTypeDTO,
    ICommandParameters {}

export interface ServiceTypeDTO {
  active: boolean;
  name: string;
  description: string;
  hourly: boolean;
  oneWay: boolean;
  roundTrip: boolean;
  courier: boolean;
  defaultPickupType: string;
  defaultDropoffType: string;
  vehicleTypeProgrammedAll: boolean;
  vehicleTypeOnDemandAll: boolean;
  extraOptionsAll: boolean;
  vehicleTypesOnDemand: number[] | null;   // Puede ser un array de números o null
  vehicleTypesProgrammed: number[] | null;
  otherCosts: number[];                    // Array de IDs de carrierOtherCost
  userId: number;
  type?: string;

  contractorAccountId?: number;
  carrierRateId?: number;
  defaultPaymentMethod?: string;
  paymentTerm?: number;
  pickupAreaId?: number;
  dropoffAreaId?: number;

  //Nuevos valores MX-4760
  allowStops?: boolean;
  authRequired?: boolean;
  hasUseLimit?: boolean;
  periodType?: string;
  dateFrom?: any;            // ISO 8601 date
  dateTo?: any;              // ISO 8601 date
  paxQtyRequired?: number;
  hasAvailabilityTime: boolean;
  schedule?: ScheduleDto[];
  employees?: number[];
  useLimit?: number;

  
  //TICKET 4826
  showPax?: boolean;
  shortName?: string;
  iconUrl?: string;
  predefPickup?: string;
  setPickup?: string;
  predefDropoff?: string;
  setDropoff?: string;
}